import { Flex, Icon, Text } from '@lemonade-hq/uniclient-theme';
import { clsx } from 'clsx';
import { FULLSTORY_MASK_CLASSNAME } from '../utils/consts';
import * as styles from './WizardHistory.css';

interface WizardHistoryEntryProps {
  readonly showEdit?: boolean;
  readonly editVisible?: boolean;
  readonly value?: string;
}

export const WizardHistoryOutput: React.FC<WizardHistoryEntryProps> = ({
  value,
  showEdit = true,
  editVisible = true,
}) => {
  return (
    <Flex alignItems="end">
      <Text className={clsx(styles.value, FULLSTORY_MASK_CLASSNAME)} data-private display="inline" type="bodyMedium">
        {value}
      </Text>
      {showEdit && (
        <Icon
          className={styles.editIcon}
          containerClassName={styles.editIconContainer}
          name="edit"
          size="md"
          style={{
            opacity: editVisible ? 1 : 0,
          }}
          tabIndex={editVisible ? 0 : -1}
          variant="secondary"
        />
      )}
    </Flex>
  );
};
